import React from "react";
import PropTypes from "prop-types";

class ReactTableRangeFilter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            minValue: "",
            maxValue: ""
        };
    }

    componentDidMount() {
        // Initialize with current filter values if they exist
        const { filter } = this.props;
        if (filter && filter.value) {
            const range = filter.value.split('-');
            this.setState({
                minValue: range[0] || "",
                maxValue: range[1] || ""
            });
        }
    }

    handleMinChange = (event) => {
        const minValue = event.target.value;
        this.setState({ minValue }, () => {
            this.updateFilter(this.state.minValue, this.state.maxValue);
        });
    };

    handleMaxChange = (event) => {
        const maxValue = event.target.value;
        this.setState({ maxValue }, () => {
            this.updateFilter(this.state.minValue, this.state.maxValue);
        });
    };

    updateFilter = (min, max) => {
        const { onChange } = this.props;
        
        if (min === "" && max === "") {
            onChange(undefined);
        } else if (min === "" && max !== "") {
            onChange(`-${max}`);
        } else if (min !== "" && max === "") {
            onChange(`${min}-`);
        } else {
            onChange(`${min}-${max}`);
        }
    };

    render() {
        const { minValue, maxValue } = this.state;
        const { style } = this.props;

        return (
            <div style={{ display: 'flex', gap: '4px', alignItems: 'center', ...style }}>
                <input
                    type="number"
                    placeholder="Min"
                    value={minValue}
                    onChange={this.handleMinChange}
                    style={{ 
                        width: '60px', 
                        height: '100%', 
                        padding: '4px',
                        border: '1px solid #ccc',
                        borderRadius: '3px'
                    }}
                />
                <span style={{ fontSize: '12px', color: '#666' }}>-</span>
                <input
                    type="number"
                    placeholder="Max"
                    value={maxValue}
                    onChange={this.handleMaxChange}
                    style={{ 
                        width: '60px', 
                        height: '100%', 
                        padding: '4px',
                        border: '1px solid #ccc',
                        borderRadius: '3px'
                    }}
                />
            </div>
        );
    }
}

ReactTableRangeFilter.propTypes = {
    onChange: PropTypes.func.isRequired,
    filter: PropTypes.object,
    style: PropTypes.object
};

export default ReactTableRangeFilter;
